module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/9b6365fc68820b626eedbbb0060f6ead.png";